module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S7 Black.d9a7c6bf.png";